<template>
  <div>
    <div class="Rbt" id="UserLoginBlock" v-show="!authorized">
      <div class="Ava"></div>
      <div class="Enter" @click="showSignInForm()">Войти<!--</br>Зарегестрироваться --></div>
    </div>
    <div class="Rbt" id="UserInfoBlock" v-if="authorized">
      <div class="Ava" :style='{ backgroundImage: `url(${currentUser.avatar_preview_40})` }'></div>
      <div class="UserName">
        <b class="name">{{ currentUser.name }}</b></br>
        <span class="IdLink" @click="goTo('id')">Личный кабинет</span> &nbsp;&nbsp;
        <span id="UserSignOut" @click="doLogOut">Выйти</span>
      </div>
    </div>
  </div>
</template>

<script>
import { API_ROOT } from "../utils/api_root";
import { mapGetters } from 'vuex';

export default {
  // name: "UserBlock",
  // props: {},
  computed: {
    ...mapGetters(['currentUser', 'authorized']),
  },
  methods: {
    showSignInForm() {
      this.$store.commit('onShowSignIn');
    },
    doLogOut() {
      this.$http.delete(`${API_ROOT}/auth/sign_out`)
        .then(response => {
          console.log('UserBlock signout success', response);
          this.$store.commit('currentUser', null);
          this.$store.commit('auth', null);
          this.$cookie.delete('authHeaders');
        })
        .catch(error => {
          console.log('UserBlock signout error', response.response.data);
          this.$store.commit('currentUser', null);
          this.$store.commit('auth', null);
          this.$cookie.delete('authHeaders');
        });
    }
  }
};
</script>

<style>

.Ava{
  position: relative;
  width:40px;
  height: 40px;
  top: -1px;
  background-image: url("../assets/img/ava-1.png");
  background-size: cover;
  background-color: #595e5d;
}

.UserName{
  position: relative;
  left: 50px;
  top: -40px;
  width: 150px;
  height: 40px;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 13px;
  line-height: 1.3;
  color: #838383;
  font-weight: normal;
}

.Enter{
  position: relative;
  cursor: pointer;
  left: 50px;
  top: -40px;
  width: 150px;
  height: 40px;
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 16px;
  text-decoration: underline;
  line-height: 1.2;
  color: #4e9f90;
  font-weight: normal;
}
.Enter:hover{
  color: #fff;
}

.MenuLine #UserInfoBlock {
  /*display: none;*/
}

.MenuLine #UserInfoBlock .Ava {
  background-size: cover;
}

.MenuLine #UserInfoBlock .UserName .name {
  font-family: 'Roboto Condensed', sans-serif;
  font-size: 16px;
}

.MenuLine #UserInfoBlock #UserSignOut,
.MenuLine #UserInfoBlock .IdLink {
  cursor: pointer;
  font-family: 'Roboto Condensed', sans-serif;
  text-decoration: underline;
}

#UserSignOut:hover,
.IdLink:hover {
  color: #FFF;
}

</style>
